<template>
    <el-drawer :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" :title="title"
        :direction="'btt'" :before-close="handleClose">
        <div class="d-flex flex-col gap-4 mb-6">
            <div class="switch-wrapper d-flex align-items-start">
                <div class="d-flex align-items-center">
                    <div v-html="icon"></div>
                    <div class="shift_locum ml-2 d-flex flex-column">
                        <span class="label-title">{{ title }}</span>
                        <span class="label-sub">{{ description }}</span>
                    </div>
                </div>
                <el-tag class="ml-auto info" type="info">
                    <span>{{ selectedCount }}</span> of <span>{{ totalCount }}</span>
                </el-tag>
            </div>

            <div class="list-action d-flex justify-content-between align-items-center">
                <el-checkbox v-model="selectAll" @change="toggleSelectAll">
                    Select All
                </el-checkbox>
                <el-button type="text" class="text-only w-auto mt-0" @click="clearSelection" :disabled="!selectedCount">
                    Clear selection
                </el-button>
            </div>

            <div class="searchbar">
                <el-input v-model="searchTerm" :placeholder="searchPlaceholder" clearable>
                    <template #prefix>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                                stroke="#484848" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </template>
                </el-input>
            </div>

            <div class="profesional-list">
                <el-checkbox-group :model-value="selected" @update:modelValue="$emit('update:selected', $event)">
                    <div v-for="item in filteredItems" :key="item.id" class="professionals-row">
                        <ProfessionalItem :item="item" :show-info-icon="showInfoIcon" :icon=icon :type=type
                            @show-details="$emit('show-details', $event)" />
                    </div>
                </el-checkbox-group>
            </div>
        </div>

        <div class="drawer-footer d-flex">
            <el-button class="outlined flex-1" @click="cancel">Cancel</el-button>
            <el-button type="primary" @click="submit" :disabled="!selectedCount">Select</el-button>
        </div>
    </el-drawer>
</template>

<script>
import { ref, computed, watch } from 'vue';
import ProfessionalItem from './ProfessionalItem.vue';

export default {
  components: { ProfessionalItem },
  props: {
    modelValue: Boolean, // For drawer visibility
    title: String,
    description: String,
    searchPlaceholder: {
      type: String,
      default: 'Search Professional...'
    },
    icon: String,
    items: Array,
    selected: Array, // For selected items
    showInfoIcon: {
      type: Boolean,
      default: true  // Default to showing the icon if prop not provided
    },
    type: String,
  },
  emits: ['update:modelValue', 'update:selected', 'submit'],
  setup(props, { emit }) {
    const searchTerm = ref('');
    const selectAll = ref(false);
    const internalSelected = ref([...props.selected]);
    
    const filteredItems = computed(() => {
      const selectedSet = new Set(props.selected);

      let filtered = props.items;

      if (searchTerm.value) {
        filtered = filtered.filter(item =>
          item.name?.toLowerCase().includes(searchTerm.value.toLowerCase())
        );
      }

      filtered = filtered.slice().sort((a, b) => {
        const aSelected = selectedSet.has(a.id);
        const bSelected = selectedSet.has(b.id);

        // First: Selected items come first
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;

        // Then: Alphabetical by name (case-insensitive)
        const aName = a.name?.toLowerCase() || '';
        const bName = b.name?.toLowerCase() || '';
        return aName.localeCompare(bName);
      });

      return filtered;
    });
    
    const selectedCount = computed(() => props.selected.length);
    const totalCount = computed(() => props.items.length);
    // Sync internalSelected with props.selected
    watch(() => props.selected, (newVal) => {
      internalSelected.value = [...newVal];
    });
    
    const toggleSelectAll = (val) => {
      const newSelection = val ? props.items.map(item => item.id) : [];
      emit('update:selected', newSelection);
    };
    
    const clearSelection = () => {
      selectAll.value = false;
      emit('update:selected', []);
    };
    
    const showDetails = (item) => {
      console.log("🚀 ~ showDetails ~ item:", item)
      // Handle show details logic
    };
    
    const cancel = () => {
      searchTerm.value = '';
      emit('update:modelValue', false);
    };
    
    const submit = () => {
      searchTerm.value = '';
      emit('submit', props.selected);
      emit('update:modelValue', false);
    };
    
    const handleClose = (done) => {
      searchTerm.value = '';
      cancel();
      done();
    };
    
    return {
      searchTerm,
      selectAll,
      filteredItems,
      selectedCount,
      toggleSelectAll,
      clearSelection,
      showDetails,
      cancel,
      submit,
      handleClose,
      totalCount
    };
  }
};
</script>